import { Sites } from '@ps/platform-message-framework/common/Sites';
import React, { useEffect } from 'react';
import { useField, useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useFirstRender from '@swf/core/hooks/useFirstRender';
import { select } from '@swf/core/store';

import ESFields from './components/ESFields/ESFields';
import PTFields from './components/PTFields/PTFields';

interface Props {
  formVisible: boolean;
}

const Fields: React.FC<Props> = () => {
  const signupCountry = useSelector(select.account.getCountry);
  const firstRender = useFirstRender();
  const form = useForm();
  const site = useSelector(select.cms.getSiteId);

  const {
    input: { value: country }
  } = useField('country', { initialValue: signupCountry });

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true }, initialValue: signupCountry });

  useEffect(() => {
    if (firstRender) return;
    form.change('docOtherTypeName');
    form.change('nationalDocumentNumber');

    const fieldsToReset = ['nationalDocumentNumber', 'docNumber', 'state', 'docType'];
    const registeredFields = form.getRegisteredFields();

    fieldsToReset.forEach((field) => {
      if (registeredFields.includes(field)) {
        form.resetFieldState(field);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citizenship, country]);

  return (
    <fieldset data-testid="identity-verification-form-fields">
      {(site === Sites.SPA || site !== Sites.POR) && <ESFields />}
      {site === Sites.POR && <PTFields />}
    </fieldset>
  );
};

export default Fields;
